class GallerySection extends HTMLElement {
  constructor() {
    super();
    this.shown = 0;
    this.batch = 3;
    /** @type {HTMLElement[]} */
    this.items = [];
    /** @type {HTMLElement|null} */
    this.popup = null;
    /** @type {string} */
    this.currentDesignTitle = '';
    this._onKeydown = (/** @type {KeyboardEvent} */ e) => {
      if (e.key === 'Escape') this.closePopup();
    };
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.gallery__item--more'));
    const footer = this.querySelector('.gallery__footer');

    if (this.items.length === 0) {
      footer?.remove();
    } else {
      this.querySelector('.gallery__load-more')?.addEventListener('click', () => this.loadMore());
    }

    this.popup = this.querySelector('.gallery-popup');

    this.querySelectorAll('[data-popup-image]').forEach((item) => {
      item.addEventListener('click', () => this.openPopup(/** @type {HTMLElement} */ (item)));
    });

    this.querySelector('.gallery-popup__close')?.addEventListener('click', () => this.closePopup());

    this.querySelector('.gallery-popup__overlay')?.addEventListener('click', () => this.closePopup());

    this.querySelector('.gallery-popup__btn--primary')?.addEventListener('click', (e) => this.openEnquiryPopup(e));

    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeydown);
  }

  /** @param {HTMLElement} item */
  openPopup(item) {
    if (!this.popup) return;

    const {
      popupImage,
      popupImageMobile,
      popupImageAlt,
      popupTitle,
      popupDescription,
      popupBtn1Label,
      popupBtn1Url,
      popupBtn2Label,
      popupBtn2Url,
    } = item.dataset;

    const source = /** @type {HTMLSourceElement|null} */ (this.popup.querySelector('.gallery-popup__source-mobile'));
    if (source) source.srcset = popupImageMobile || '';

    const img = /** @type {HTMLImageElement|null} */ (this.popup.querySelector('.gallery-popup__image'));
    if (img) {
      img.src = popupImage || '';
      img.alt = popupImageAlt || '';
    }

    const titleEl = this.popup.querySelector('.gallery-popup__title');
    if (titleEl) titleEl.textContent = popupTitle || '';

    const textEl = this.popup.querySelector('.gallery-popup__text');
    if (textEl) textEl.textContent = popupDescription || '';

    const btn1 = this.popup.querySelector('.gallery-popup__btn--primary');
    if (btn1) {
      const span = btn1.querySelector('span');
      if (span) span.textContent = popupBtn1Label || '';
      /** @type {HTMLElement} */ (btn1).style.display = popupBtn1Label ? '' : 'none';
    }

    const btn2 = this.popup.querySelector('.gallery-popup__btn--secondary');
    if (btn2) {
      btn2.setAttribute('href', popupBtn2Url || '#');
      const span = btn2.querySelector('span');
      if (span) span.textContent = popupBtn2Label || '';
      /** @type {HTMLElement} */ (btn2).style.display = popupBtn2Label ? '' : 'none';
    }

    this.popup.setAttribute('aria-hidden', 'false');
    this.popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    this.currentDesignTitle = popupTitle || '';
  }

  /** @param {Event} e */
  openEnquiryPopup(e) {
    e.preventDefault();

    this.closePopup();

    const enquiryPopup = document.querySelector('[id^="gallery-enquiry-popup-"]');
    if (enquiryPopup) {
      const titleEl = enquiryPopup.querySelector('.gallery-enquiry__design-title');
      if (titleEl) titleEl.textContent = this.currentDesignTitle;

      const hiddenInput = /** @type {HTMLInputElement|null} */ (
        enquiryPopup.querySelector('[data-gallery-design-title]')
      );
      if (hiddenInput) hiddenInput.value = this.currentDesignTitle;

      const textarea = /** @type {HTMLTextAreaElement|null} */ (
        enquiryPopup.querySelector('.gallery-enquiry-form__input--textarea')
      );

      if (textarea && this.currentDesignTitle) {
        const messageTemplate = textarea.dataset.defaultValue || '';
        textarea.value = messageTemplate.replace('{title}', this.currentDesignTitle);
      }

      const dialog = /** @type {HTMLDialogElement|null} */ (enquiryPopup.querySelector('dialog'));
      if (dialog) dialog.showModal();
    }
  }

  closePopup() {
    if (!this.popup) return;
    this.popup.classList.remove('is-open');
    this.popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  loadMore() {
    this.items.slice(this.shown, this.shown + this.batch).forEach((item) => item.classList.add('is-visible'));

    this.shown = Math.min(this.shown + this.batch, this.items.length);

    if (this.shown >= this.items.length) {
      this.querySelector('.gallery__footer')?.remove();
    }
  }
}

customElements.define('gallery-section', GallerySection);
